var _mask, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAccountUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    width: "100%",
    height: "100%",
    viewBox: "0 0 42 42",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    x: 0,
    y: 0,
    width: 42,
    height: 42,
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 21,
    cy: 21,
    r: 21,
    fill: "#EFF2F5"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 21,
    cy: 21,
    r: 21,
    fill: "#EFF2F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m32.798 32.281-5.6237-1.1388c-0.5966-0.1196-1.0311-0.6552-1.0311-1.274v-1.3052c0.3702-0.52 0.7174-1.2142 1.0774-1.9396 0.2751-0.5486 0.6891-1.3754 0.8743-1.5704 1.0903-1.079 2.2525-2.418 2.6074-4.1626 0.3214-1.5808 0-2.4024-0.3729-3.0524 0-1.2714 0-3.5984-0.4371-5.2754-0.0437-2.0254-0.4114-3.1694-1.3346-4.1886-0.6531-0.7124-1.6148-0.8788-2.3863-1.0114-0.306-0.052-0.7251-0.1248-0.8717-0.2054-1.3345-0.7462-2.6897-1.1154-4.3483-1.157-3.3942 0.13-7.56 2.3062-8.9537 6.2192-0.4243 1.1882-0.3831 3.1382-0.3523 4.706l-0.036 0.9126c-0.3265 0.65-0.648 1.4716-0.324 3.0498 0.3549 1.7524 1.5172 3.0888 2.6023 4.1626 0.1877 0.1976 0.6069 1.0296 0.8846 1.5782 0.3651 0.7228 0.7149 1.417 1.0851 1.937v1.3026c0 0.6188-0.4345 1.1544-1.0337 1.274l-5.6237 1.1388c-3.5923 0.7254-6.1997 3.9416-6.1997 7.6466v2.4726c0 1.4326 1.1546 2.6 2.5714 2.6h30.857c1.4168 0 2.5714-1.1674 2.5714-2.6v-2.4726c0-3.705-2.6074-6.9212-6.2023-7.6466z",
    fill: "#B6BFC6"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccountUser);
export default __webpack_public_path__ + "static/media/account_user.0305d32e0f3c4ecf333222f9c0f7988e.svg";
export { ForwardRef as ReactComponent };